
  function handleTickInit(tick) {
    // get the element
    var el = document.getElementById("my-flip");

    // read the custom attribute
    var userInput = el.getAttribute("data-input");

    // split by comma → array of words
    var rotation = userInput.split(",").map(function(item) {
      return item.trim();
    }).filter(Boolean); // remove empty entries

    var index = 0;

    Tick.helper.interval(function() {
      tick.value = rotation[index];
      index = (index + 1) % rotation.length;
    }, 5000);
  }